import { ChangeEvent } from "react";
import { useParams } from "react-router";
import useGetImporter from "../../../api/useGetImporter";
import usePostImporter from "../../../api/usePostImporter";
import Box from "../../../components/Box";
import Errors from "../../../components/Errors";
import Switch from "../../../components/Switch";
import style from "./style/WebhookSwitch.module.scss";

export default function WebhookSwitch() {
  const { importerId } = useParams();

  const { data: importer, isLoading } = useGetImporter(importerId && importerId !== "new" ? importerId : "");

  const { webhooks_enabled: enabled } = importer || {};

  const { mutate, error } = usePostImporter("", importer?.id);

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    mutate({ id: importer?.id, webhooks_enabled: e?.target?.checked });
  };

  if (isLoading) return null;

  return (
    <>
      <h3>Webhooks</h3>
      <p>
        Notify an application about import events. Webhook destinations can be configured in your workspace <a href="/settings">settings</a>.
      </p>
      <Box className={style.box} variants={["bg-shade"]}>
        <div className={style.switchWrapper}>
          <label>Enable webhooks:</label>
          <Switch className={style.switch} checked={!!enabled} onChange={onChange} />
        </div>
      </Box>
      <Errors error={error} />
    </>
  );
}
